/**
 * Built-in presets
 * @module
 */
export * as classic from './classic'
